import { render, staticRenderFns } from "./message-settings.vue?vue&type=template&id=13cf2dde&scoped=true"
import script from "./message-settings.vue?vue&type=script&lang=js"
export * from "./message-settings.vue?vue&type=script&lang=js"
import style0 from "./message-settings.vue?vue&type=style&index=0&id=13cf2dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf2dde",
  null
  
)

export default component.exports